module.exports = __webpack_public_path__ + "img/-s-pic_product zdyw_jsts.256f8de1.svg";